import { render, staticRenderFns } from "./menuItemRow.vue?vue&type=template&id=1f033698&scoped=true"
import script from "./menuItemRow.vue?vue&type=script&lang=js"
export * from "./menuItemRow.vue?vue&type=script&lang=js"
import style0 from "./menuItemRow.vue?vue&type=style&index=0&id=1f033698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f033698",
  null
  
)

export default component.exports